<div class="home4-feature-section two mb-110">
  <div class="container">
    <div class="feature-bottom-area">
      <div class="container-fluid">
        <div class="row g-4">
          <div
            class="col-lg-11 col-11 wow animate fadeInUp"
            data-wow-delay="400ms"
            data-wow-duration="1500ms"
          >
            <div
              (click)="navigateTo('join-as-professional')"
              class="feature-banner three sell"
              style="
                background-image: linear-gradient(
                    180deg,
                    rgba(11, 12, 12, 0.8) 0%,
                    rgba(11, 12, 12, 0.8) 100%
                  ),
                  url(/assets/images/seller.jpg);
              "
            >
              <div class="banner-content">
                <h2>
                  <a
                    routerLink="/join-as-professional"
                    [attr.data-translation-key]="
                      'buyer_homepage_how_to_sell_your_item'
                    "
                    >{{ 'buyer_homepage.how_to_sell_your_item' | translate }}</a
                  >
                </h2>
              </div>
              <a routerLink="/join-as-professional" class="arrow">
                <svg
                  width="96"
                  height="96"
                  viewBox="0 0 96 96"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path
                      d="M48.2376 0.238115L96.0006 48.001L87.0593 56.9423L9.02935 57.0308L8.94081 39.0597L61.9082 39.3207L35.2963 13.1794L48.2376 0.238115Z"
                    />
                    <path
                      d="M48 96.002L78.118 65.8841L52.5801 65.7583L35.1682 83.1702L48 96.002Z"
                    />
                  </g>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
